var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizes-2021-game-place"},[_c('Prizes2021GamePlaceImage'),_c('Prizes2021GamePlaceDescription')],1)}
var staticRenderFns = []

export { render, staticRenderFns }